import React from 'react'
import { Typography, Avatar, 
  } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types'

const useStylesMessageNode= makeStyles(theme=>({
    avatar: {
        width:65,
        height:65
    },
    root:{
        display: 'flex',   
        alignItems: 'center',
        padding: '4px 0px'
    },
    data:{
        paddingLeft: 8
    }
}))
const MessageMultiple =(props)=>{
    const classesMsg = useStylesMessageNode()
    const {imageSrc, title, msg, children} = props
    return(
        <div className={classesMsg.root}>
             <Avatar 
                alt= "image"
                src= {imageSrc}
                className={classesMsg.avatar}
                />
            
            <div className={classesMsg.data}>
            <div>{children}</div>
            <Typography varient="h6">{title}</Typography>
            <Typography variant="body1">{msg}</Typography>
            </div>
        </div>
    )
}
export default MessageMultiple
MessageMultiple.propTypes = {
    title: PropTypes.string,
    msg: PropTypes.string.isRequired,
    imageSrc: PropTypes.string.isRequired
  };